import { render, staticRenderFns } from "./AxTripList.vue?vue&type=template&id=56035a2e&scoped=true&"
import script from "./AxTripList.vue?vue&type=script&lang=js&"
export * from "./AxTripList.vue?vue&type=script&lang=js&"
import style0 from "./AxTripList.vue?vue&type=style&index=0&id=56035a2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56035a2e",
  null
  
)

export default component.exports